"use client";
import SearchBox from "@/core/common/SearchBox";
import React from "react";
import PackageView from "./PackageViewType";
import { useSearchParams } from "next/navigation";

interface FilterSectionProps {
  totalItems: number;
}

const FilterSection: React.FC<FilterSectionProps> = ({ totalItems }) => {
  const searchParams = useSearchParams();

  const searchQuery = searchParams.get ? searchParams.get("search") : "";
  return (
    <div className="flex items-center justify-between mb-5">
      <div>
        <p className="typography-extra-large-body text-grey-600">
          {searchQuery || "All Packages"}
        </p>
        <p className="typography-small-body text-grey-600">
          {totalItems} item{totalItems !== 1 ? "s" : ""} found for:{" "}
          {searchQuery || "All Packages"}
        </p>
      </div>
      <div className="inline-flex gap-3">
        <SearchBox placeholder="Search..." />
        <PackageView />
      </div>
    </div>
  );
};

export default FilterSection;
